import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Link, NavLink } from 'react-router-dom'
import { NAV_ITEMS, SITE } from '../data/site'
import { SearchBox } from './SearchBox'
import './Header.css'

export function Header() {
  const [open, setOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        setOpen(false)
        setSearchOpen(false)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const menu = open
    ? createPortal(
        <>
          <button
            type="button"
            className="nav-backdrop"
            aria-label="மெனு மூடு"
            onClick={() => setOpen(false)}
          />
          <div className="nav-drawer is-open" role="dialog" aria-modal="true" aria-label="மெனு">
            <div className="nav-drawer__head">
              <span>மெனு</span>
              <button type="button" className="nav-drawer__close" onClick={() => setOpen(false)} aria-label="மெனு மூடு">
                <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2.4">
                  <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
                </svg>
              </button>
            </div>
            <nav aria-label="மொபைல் மெனு">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => (isActive ? 'active' : undefined)}
                >
                  {item.labelTa}
                </NavLink>
              ))}
              <Link to="/downloads" onClick={() => setOpen(false)}>
                இலவச பதிவிறக்கங்கள்
              </Link>
            </nav>
          </div>
        </>,
        document.body,
      )
    : null

  return (
    <header className="site-header">
      <div className="container site-header__bar">
        <Link to="/" className="brand" onClick={() => setOpen(false)} aria-label={`${SITE.nameTa} முகப்பு`}>
          <img src={SITE.logoMark} alt="" width={48} height={38} />
          <span className="brand__text">
            <span className="brand__ta">{SITE.nameTa}</span>
            <span className="brand__en">{SITE.nameEn}</span>
          </span>
        </Link>

        <nav className="nav-desktop" aria-label="முதன்மை மெனு">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {item.labelTa}
            </NavLink>
          ))}
        </nav>

        <div className="site-header__actions">
          <a
            className="yt-icon"
            href={SITE.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube சேனல்"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
              <path
                fill="currentColor"
                d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8zM9.8 15.5v-7l6.3 3.5-6.3 3.5z"
              />
            </svg>
          </a>
          <button
            type="button"
            className="icon-btn"
            aria-label="தேடல்"
            aria-expanded={searchOpen}
            onClick={() => {
              setSearchOpen((v) => !v)
              setOpen(false)
            }}
          >
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="7" />
              <path d="M20 20l-3.5-3.5" strokeLinecap="round" />
            </svg>
          </button>
          <button
            type="button"
            className="icon-btn menu-btn"
            aria-label={open ? 'மெனு மூடு' : 'மெனு திற'}
            aria-expanded={open}
            onClick={() => {
              setOpen((v) => !v)
              setSearchOpen(false)
            }}
          >
            {open ? (
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="header-search container">
          <SearchBox compact autoFocus />
        </div>
      )}

      {menu}
    </header>
  )
}
